import {Component, Injector, Input, OnInit} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {TechnicalDeviceApiService} from '@api/technical-device.api.service';
import {TechnicalDeviceNamespace} from '@namespaces/technical-device.namespace';

@Component({
    selector: 'app-technical-device-set-status-form',
    templateUrl: 'technical-device-set-status-form.component.html'
})

export class TechnicalDeviceSetStatusFormComponent extends FrontendFormComponent {
    @Input() deviceId: number;
    @Input() deviceStatus: number;

    public statuses = TechnicalDeviceNamespace.StatusesList;

    public afterSaveMessage = 'Состояние успешно изменено';

    constructor(
        injector: Injector,
        public formService: TechnicalDeviceApiService,
    ) {
        super(injector);
    }

    init() {
        this.form = this._fb.group({
            id: [this.deviceId || ''],
            status: [this.deviceStatus || '']
        });
    }

    get saveUrl() {
        return this.formService.getSetStatusUrl(this.deviceId);
    }
}
